/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Create_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to create API key. Please try again." |
*
* @param {Profile_Security_User_Api_Key_Create_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_create_error = /** @type {((inputs?: Profile_Security_User_Api_Key_Create_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Create_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel konnte nicht erstellt werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Failed to create API key. Please try again.")
});